import React from 'react'
import moment from 'moment'
import { JOB_COLOR } from 'utils/constants/ColorTheme'

export default class JobLogTable {
    constructor(obj = {}) {
        this.id = obj.id
        this.comment = obj.comment
        this.status = obj.status
        this.value = obj.status === 'link' ? obj.value.split(' ').map(s => s.startsWith('http') ? <a key={s} href={s} className='clickable  fileLabelWithPath'>{s}</a> : `${s} `) : obj.value
        this.date = obj.date && moment(obj.date).format('DD/MM/YYYY HH:mm:ss')
        this.timestamp = obj.date
        this.station = obj.station
        this.jobExecutionId = obj.jobExecutionId
        this.colorLine = obj.status === 'success' ? JOB_COLOR.GREEN : (obj.status === 'error' ? JOB_COLOR.RED : (obj.status === 'warning' ? JOB_COLOR.YELLOW : null))
        this.fileName = obj.fileName
        this.fileLabel = obj.fileLabel || obj.fileName
    }
}
